import { render } from "./BusinessEducation.vue?vue&type=template&id=06628db0&scoped=true"
import script from "./BusinessEducation.vue?vue&type=script&lang=js"
export * from "./BusinessEducation.vue?vue&type=script&lang=js"

import "./BusinessEducation.vue?vue&type=style&index=0&id=06628db0&scoped=true&lang=css"
import "./BusinessEducation.vue?vue&type=style&index=1&id=06628db0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06628db0"]])

export default __exports__